import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

function TermsOfService() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <a href="/" className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Is It Taxed
            </a>
            <a href="/">
              <Button variant="outline" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Button>
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Card className="border-2">
          <CardContent className="p-8">
            <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Terms of Service
            </h1>
            <p className="text-sm text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-2xl font-bold mb-3">1. Acceptance of Terms</h2>
                <p>
                  [Your legal advisor will provide this content]
                </p>
                <p>
                  By accessing or using Is It Taxed, you agree to be bound by these Terms of Service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">2. Description of Service</h2>
                <p className="mb-4">
                  [Your legal advisor will provide this content]
                </p>
                <p>
                  Is It Taxed provides UK vehicle tax and MOT status checking services using official DVLA data.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">3. User Accounts</h2>
                <h3 className="text-xl font-semibold mb-2">3.1 Account Creation</h3>
                <p className="mb-4">
                  [Your legal advisor will provide this content]
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>You must provide accurate information</li>
                  <li>You are responsible for account security</li>
                  <li>You must be at least 16 years old</li>
                  <li>One account per user</li>
                </ul>

                <h3 className="text-xl font-semibold mb-2 mt-4">3.2 Account Termination</h3>
                <p>
                  We reserve the right to suspend or terminate accounts for violations of these terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">4. Acceptable Use</h2>
                <p className="mb-4">
                  [Your legal advisor will provide this content]
                </p>
                <p className="mb-2">You agree NOT to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Use automated systems to scrape data</li>
                  <li>Circumvent rate limits or restrictions</li>
                  <li>Resell or redistribute our data</li>
                  <li>Use the service for illegal purposes</li>
                  <li>Violate any applicable laws or regulations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">5. Premium Subscription</h2>
                <h3 className="text-xl font-semibold mb-2">5.1 Pricing and Payment</h3>
                <p className="mb-4">
                  [Your legal advisor will provide this content]
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Monthly: £4.99/month</li>
                  <li>Annual: £49/year</li>
                  <li>Processed securely via Stripe</li>
                  <li>Prices subject to change with notice</li>
                </ul>

                <h3 className="text-xl font-semibold mb-2 mt-4">5.2 Cancellation and Refunds</h3>
                <p className="mb-4">
                  [Your legal advisor will provide this content]
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Cancel anytime via account settings</li>
                  <li>No refunds for partial months</li>
                  <li>Access continues until end of billing period</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">6. Data Accuracy and Limitations</h2>
                <p className="mb-4">
                  [Your legal advisor will provide this content]
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>We provide information "as is" from DVLA</li>
                  <li>We are not responsible for DVLA data accuracy</li>
                  <li>Images are for illustration only</li>
                  <li>Always verify critical information with DVLA directly</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">7. Intellectual Property</h2>
                <p>
                  [Your legal advisor will provide this content]
                </p>
                <p>
                  All content, trademarks, and intellectual property belong to Is It Taxed unless otherwise stated.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">8. Limitation of Liability</h2>
                <p>
                  [Your legal advisor will provide this content]
                </p>
                <p>
                  We are not liable for decisions made based on information provided by our service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">9. Changes to Terms</h2>
                <p>
                  [Your legal advisor will provide this content]
                </p>
                <p>
                  We may update these terms. Continued use constitutes acceptance of updated terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">10. Governing Law</h2>
                <p>
                  [Your legal advisor will provide this content]
                </p>
                <p>
                  These terms are governed by the laws of England and Wales.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-3">11. Contact Information</h2>
                <p className="mb-2">
                  [Your legal advisor will provide this content]
                </p>
                <ul className="space-y-1">
                  <li>Email: [YOUR EMAIL]</li>
                  <li>Address: [YOUR ADDRESS]</li>
                </ul>
              </section>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-8">
                <p className="text-sm text-yellow-800">
                  <strong>Note:</strong> This is a template structure. Please have a legal professional review and complete these Terms of Service to ensure compliance with UK law and Google Play Store requirements.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default TermsOfService;
